module.exports = __webpack_public_path__ + "img/leader.ffb346e2.png";